import { isValidSecurityCode } from '../../../../shared/validators/isValidSecurityCode.js';
import { getOtpView, getOtpBtnSubmit, hideOtpError, showOtpError } from './getOtpView.js';
import { registerSession } from '../../api/registerSession.js';
import progressBar from '../../../../shared/DOM/progressBar.js';
import { disableLanguage } from '../../../../shared/DOM/disableLanguage.js';
import { getTargetViewName } from '../../../../shared/DOM/getTargetViewName.js';
import { ERROR_CREDENTIALS, onCatchError } from '../renderError.js';
import { renderViewdocsHeader } from '../renderViewdocsHeader.js';
import { renderViewDocsWorkflow } from '../workflow/renderViewDocsWorkflow.js';

export function renderOtp(token, viewdocsData, link) {
  const eForm = document.getElementById(`form-viewdocs${viewdocsData.form}`);
  eForm.render({
    view: getOtpView(),
  });

  // No hemos pasado por el login
  link && renderViewdocsHeader('check', 'viewdoc.step.intro.title');

  hideOtpError();

  initOtp();

  /////////////////////////////

  function initOtp() {
    disableLanguage();

    eForm.addEventListener('keyup', (event) => {
      if (event.key === 'Enter' && !!getOtpBtnSubmit()) {
        submitOtpForm();
      }
    });

    eForm.addEventListener('click', (event) => {
      const target = getTargetViewName(event);

      if (target === 'btnOtp') {
        submitOtpForm();
      }
    });
  }

  // eBtnSubmit
  async function submitOtpForm() {
    const eBtnSubmit = getOtpBtnSubmit();

    if (!eBtnSubmit || eBtnSubmit.state === 'loading') {
      return;
    }

    try {
      eBtnSubmit.state = 'loading';
      progressBar.loading();

      const { code } = eForm.value;

      // eForm.valid personalizado
      const valid = isValidSecurityCode(code);

      // Exit error
      if (!valid) {
        throw new Error('login.otpcode_invalid');
      }

      // set security code
      viewdocsData.seccode = code;

      // Podemos tener ya el token si sólo necesitamos el otp para el print
      const tokena = token || (await registerSession(viewdocsData));
      if (tokena) {
        renderViewDocsWorkflow(tokena, viewdocsData);
      }
      // else no token + no error > navigateTo

      // Finalizamos correctamente por si navegan hacia atrás en el navegador:
      progressBar.resolved();
      // Con retardo para visualizar solo el check de ok
      setTimeout(() => {
        eBtnSubmit.state = 'resolved';
      }, 1000);
    } catch (e) {
      eBtnSubmit.state = 'rejected';
      progressBar.rejected();

      if (e.message === ERROR_CREDENTIALS) {
        showOtpError('login.error_otp_invalidcode');
      } else {
        onCatchError(e, viewdocsData);
      }
    }
  }
}
